import {
  JobsApiClientInterface,
  JobsApiClientModel,
  JobsApiClientUrlsInterface,
} from '../../../models/api-client/models';
//import {config} from '../../../config';

const urls: JobsApiClientUrlsInterface = {
  // this should be pointing to your live API end-point
  fetchJobs: 'https://yourapi-endpoint...',
};
// instantiate the ItemsApiClient pointing at the url that returns static json mock \
//data
const jobsApiClient: JobsApiClientInterface = new JobsApiClientModel({urls});
// export our instance
export {jobsApiClient};
